//
// IMPORTS
//

// Base URL for the API
import { apiUrl } from '@/constants'

import { testFbId } from './index'

import { httpRequest } from '@/services/api'

//
//
//
// ENDPOINTS PARA O GESTOR DE PLANOS
//
//
//

// Atualiza o plano personalizado de um usuário
const apiUpdateUserCustomPlan = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/userplan/save`, payload, headers: { 'Authorization': `Bearer ${token}` } })

// Desfaz o plano personalizado de um usuário
const apiUndoUserCustomPlan = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/userplan/undo`, payload, headers: { 'Authorization': `Bearer ${token}` } })

// Ler capacidades de um usuário
const apiGetUserCapabilities = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/userplan`, payload, headers: { 'Authorization': `Bearer ${token}` } })

//
//
//
// ENDPOINTS PARA A JANELA DE PAGAMENTO
//
//
//

// Pagamento na VINDI
const apiMakePayment = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/paynew`, payload, headers: { 'Authorization': `Bearer ${token}` } })

// Ler dados pessoais de pagamento (SE HOUVER)
const apiGetUserPaymentProfile = token => httpRequest({ method: 'GET', url: `${apiUrl}/managers/me`, headers: { 'Authorization': `Bearer ${token}` } })

//
//
//
// ENDPOINTS PARA A TELA DE ASSINATURA
//
//
//

// Ativar cupom
const apiActivateCoupon = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/coupon`, payload, headers: { 'Authorization': `Bearer ${token}` } })

// Cancelar plano na VINDI
const apiCancelSubscription = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/payments/cancel`, payload, headers: { 'Authorization': `Bearer ${token}` } })

//
//
//
// ENDPOINTS DE SESSÃO
//
//
//

// Ler capacidades do usuário logado/autenticado
const apiFetchAuthenticatedUserCapabilities = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/auth`, payload, headers: { 'Authorization': `Bearer ${token}` } })

//
//
//
// GET ADDRESS BY CEP
//
//
//

const apiGetAddressByCep = cep => httpRequest({ method: 'GET', url: `https://viacep.com.br/ws/${cep}/json` })

//
//
//
// Vincula o usuário ao grupo
//
//
//

const apiAddUserToGroup = (userID = false, groupID = false, cCallback = () => {}) => {
  const updates = {
    [`grupos/${groupID}/users/${userID}`]: { admin: false, enablePush: true }, // Vincula o usuário no grupo
    [`users/${userID}/grupos/${groupID}`]: { admin: false, enablePush: true }, // Vincula o grupo no usuário
  }

  // ATUALIZA DADOS NO BANCO
  try {
    testFbId.ref().update(updates,
    error => {
      if (error) {
        cCallback({
          code: 0,
          message: 'Não foi possível adicionar o usuário no grupo',
          error,
        })
      } else {
        cCallback({
          code: 1,
          message: 'O usuário foi adicionado no grupo',
          debug: updates,
          error: '',
        })
      }
    })
  } catch (error) {
    cCallback({
      code: 0,
      message: 'Não foi possível adicionar o usuário no grupo',
      error,
    })
  }
}

//
//
//
// ?
//
//
//

const apiCreateUser = payload => httpRequest({ method: 'POST', url: `${apiUrl}/v1/users`, payload })

//
//
//
// SAÍDA
//
//
//

export {
  apiUpdateUserCustomPlan,
  apiUndoUserCustomPlan,
  apiGetUserCapabilities,

  apiMakePayment,
  apiGetUserPaymentProfile,

  apiActivateCoupon,
  apiCancelSubscription,

  apiFetchAuthenticatedUserCapabilities,

  apiGetAddressByCep,

  apiAddUserToGroup,
  apiCreateUser,
}
